import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@elparking/components'
import ShortFeatureSelection from './ShortFeatureSelection'
import RateBox from './RateBox'

const RateList = ({
  vehicleId,
  onClick,
  rates,
  carId,
}) => {
    const [ selected, setSelected ] = useState(null)
    return <Flex width='100%' flexDirection='column-reverse'>
        {rates.map((rate, index) => {
            const highlighted = index === rates.length - 1
            const marked = selected === `${rate.id}`
            return <RateBox
              p='0 20px'
              mt='10px'
              fontSize='small'
              width='100%'
              dataTest=''
              borderColor={marked ? 'accent' : 'gray10'}
              backgroundColor={marked ? 'accent10' : 'transparent'}
              key={`rate_${vehicleId}_${index}`}>
                <ShortFeatureSelection
                  carId={carId}
                  features={rate.features}
                  rate={rate}
                  selected={marked}
                  setSelected={setSelected}
                  highlighted={highlighted}
                  flexDirection='row'
                  textAlign='left'
                  onClick={onClick}/>
            </RateBox>
        })}
    </Flex>
}

RateList.propTypes = {
    vehicleId: PropTypes.any,
    rates: PropTypes.array,
    carId: PropTypes.any,
    onClick: PropTypes.func,
}

export default RateList
